export const SITE = {
  phoneDisplay: "(479) 900-8804",
  phoneTel: "+14799008804",
  hours: "Mon-Fri 8am-5pm with 24/7 Emergency Service Available",
  logoWhite:
    "https://customer-assets.emergentagent.com/job_cb9d6de7-f6da-41a1-bf20-283773492e4e/artifacts/mwa9u04z_Palmer_HVAC_white_logo.png",
  logoIcon:
    "https://customer-assets.emergentagent.com/job_cb9d6de7-f6da-41a1-bf20-283773492e4e/artifacts/9ew9uy8t_Palmer_HVAC_white_only_logo.png",
  tradesmenLogo:
    "https://customer-assets.emergentagent.com/job_cb9d6de7-f6da-41a1-bf20-283773492e4e/artifacts/34mfxv25_Untitled%20design%20%2820%29.png",
  heroBg:
    "https://customer-assets.emergentagent.com/job_palmer-hvac-pro/artifacts/58youbok_503996369_1278087994317375_1534235962343105359_n.jpg",
  aboutImg:
    "https://customer-assets.emergentagent.com/job_palmer-hvac-pro/artifacts/36jhzl6j_500167109_1271385411654300_2138612297338853881_n.jpg",
  serviceImg:
    "https://customer-assets.emergentagent.com/job_palmer-hvac-pro/artifacts/rxbp9bar_499928187_1271411401651701_7011239826645178670_n.jpg",
};

export const GALLERY = [
  {
    src: "https://customer-assets.emergentagent.com/job_palmer-hvac-pro/artifacts/58youbok_503996369_1278087994317375_1534235962343105359_n.jpg",
    alt: "Palmer HVAC team — three technicians installing commercial rooftop HVAC in Northwest Arkansas",
    caption: "Commercial Rooftop Install",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_palmer-hvac-pro/artifacts/36jhzl6j_500167109_1271385411654300_2138612297338853881_n.jpg",
    alt: "Palmer HVAC air conditioning installation — multiple outdoor AC condenser units in Northwest Arkansas",
    caption: "Multi-Unit AC Installation",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_palmer-hvac-pro/artifacts/2jiuszgd_500561084_1271383938321114_1697376448739793258_n.jpg",
    alt: "Palmer HVAC custom sheet metal ductwork fabrication and install in NW Arkansas home",
    caption: "Custom Sheet Metal Ductwork",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_palmer-hvac-pro/artifacts/rxbp9bar_499928187_1271411401651701_7011239826645178670_n.jpg",
    alt: "Palmer HVAC high-efficiency furnace installation by HVAC contractor in Northwest Arkansas",
    caption: "Furnace Installation",
  },
  {
    src: "https://customer-assets.emergentagent.com/job_palmer-hvac-pro/artifacts/5rrg6okw_499930009_1271398854986289_4500475710265033610_n.jpg",
    alt: "Palmer HVAC residential attic ductwork — heating and cooling team in Northwest Arkansas",
    caption: "Attic Ductwork & Airflow",
  },
];

export const SERVICES = [
  { title: "AC Repair", desc: "Fast, reliable air conditioning repair to restore cool comfort. Our HVAC technicians diagnose and fix all major AC brands.", icon: "Snowflake" },
  { title: "AC Installation", desc: "Energy-efficient AC installation sized correctly for your home or business. Quality HVAC contractor work, guaranteed.", icon: "Wind" },
  { title: "Heating Repair", desc: "Heating repair you can trust when temperatures drop. We service all furnaces, heat pumps, and central heating systems.", icon: "Flame" },
  { title: "Furnace Repair", desc: "Same-day furnace repair from licensed HVAC pros. Honest diagnostics and upfront pricing every time.", icon: "ThermometerSun" },
  { title: "Furnace Installation", desc: "Furnace installation and replacement with high-efficiency systems built to last NW Arkansas winters.", icon: "Cog" },
  { title: "Heat Pump Repair", desc: "Heat pump repair for year-round comfort. We tune, recharge, and rebuild systems to factory-spec performance.", icon: "Repeat" },
  { title: "Heat Pump Installation", desc: "Modern heat pump installation that lowers energy bills while delivering powerful heating and air conditioning.", icon: "Zap" },
  { title: "HVAC Maintenance", desc: "Preventive HVAC maintenance plans that extend system life, prevent breakdowns, and protect your warranty.", icon: "Wrench" },
  { title: "Seasonal Tune-Ups", desc: "Spring and fall tune-ups keep your HVAC equipment running efficiently when you need it most.", icon: "CalendarCheck" },
  { title: "Thermostat Installation", desc: "Smart thermostat installation and setup. Save on energy and control comfort from anywhere.", icon: "Gauge" },
  { title: "Indoor Air Quality", desc: "Indoor air quality solutions: filtration, purification, humidity control, and ventilation upgrades.", icon: "Leaf" },
  { title: "Ductwork", desc: "Custom ductwork design, sealing, and replacement to balance airflow and eliminate hot/cold spots.", icon: "Boxes" },
  { title: "Emergency HVAC Service", desc: "Emergency HVAC service when you need it most. We respond fast to restore heating and cooling.", icon: "Siren" },
  { title: "Residential HVAC", desc: "Full residential HVAC service for homeowners — repair, install, replace, and maintain.", icon: "Home" },
  { title: "Light Commercial HVAC", desc: "Light commercial HVAC contractor work for shops, offices, and small businesses across NW Arkansas.", icon: "Building2" },
];

export const SERVICE_AREAS = [
  "Siloam Springs",
  "Bentonville",
  "Rogers",
  "Springdale",
  "Fayetteville",
  "Bella Vista",
  "Centerton",
  "Cave Springs",
  "Lowell",
  "Tontitown",
  "Farmington",
  "Prairie Grove",
  "Gravette",
  "Decatur",
  "Gentry",
  "Northwest Arkansas",
];

export const SEO_AREA_PHRASES = [
  "HVAC repair in Siloam Springs, AR",
  "AC repair in Bentonville, AR",
  "Heating repair in Rogers, AR",
  "Furnace repair in Springdale, AR",
  "HVAC installation in Fayetteville, AR",
];

export const REVIEWS = [
  {
    name: "Pat Martin",
    rating: 5,
    text: "We had a really great experience. Adam explained things to us in terms we could understand and was honest about the repair that was actually necessary. I would recommend Palmer heating and air without reservation.",
  },
  {
    name: "Stacy Garcia",
    rating: 5,
    text: "Super grateful for Palmer Heating & Air! They were able to squeeze us in at the last minute for a quick PM on both our rent house and our current home. Showed up on time, got everything checked out fast, and were super easy to work with.",
  },
  {
    name: "Sarah Sandoval-Jastal",
    rating: 5,
    text: "Andrew and Jacob were able to do a quick and seamless job at our childcare facility. They were professional and polite. We did expect them days sooner than expected, then when the day came, we were told they would be here within a certain time and they were late. So communication about scheduling could have been better. But overall, they did a good job.",
  },
  {
    name: "Nicci Brose",
    rating: 5,
    text: "Steven and Sam came and saved the day! They were so nice, respectful, cheerful, and truly amazing at what they do! Put in an entire new unit and got us air again! So thankful for them, their incredible work, and their awesome hearts!!!!",
  },
];
